import * as Sentry from "@sentry/react"
import type { AnyRouter } from "@tanstack/react-router"

export function initSentry() {
  if (!import.meta.env.PROD) {
    return
  }

  Sentry.init({
    dsn: "https://53e818a5c4ef1cc5fd5281413c9dae58@o177333.ingest.us.sentry.io/4512327727185920",
    release: __BUILD_ID__,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
  })
}

const isPortal = (pathname: string) => pathname.split("/")[2] === "portal"

export function recordPortalReplays(router: AnyRouter) {
  const replay = Sentry.getReplay()

  if (!replay) {
    return () => {}
  }

  return router.subscribe("onResolved", ({ toLocation }) => {
    const recording = replay.getReplayId() !== undefined

    if (isPortal(toLocation.pathname)) {
      if (!recording) {
        replay.start()
      }
    } else if (recording) {
      void replay.stop()
    }
  })
}
